/* Centered toolbar element: formatted puzzle number + a real-time
   countdown to 00:00 UTC, when the next puzzle drops worldwide. The
   countdown ticks once per second; the timer self-corrects to wall-clock
   time on every tick (so a backgrounded tab catches up on resume). */

import { useEffect, useState } from "preact/hooks";
import { puzzleNumber } from "../game/state";

function msUntilNextUtcMidnight(now: Date = new Date()): number {
  const next = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() + 1,
    0,
    0,
    0,
    0,
  );
  return Math.max(0, next - now.getTime());
}

function formatHms(ms: number): string {
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export function PuzzleStatus() {
  const [hms, setHms] = useState(() => formatHms(msUntilNextUtcMidnight()));

  useEffect(() => {
    const tick = () => setHms(formatHms(msUntilNextUtcMidnight()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div class="puzzle-status" aria-live="off">
      <span class="puzzle-status__id">{puzzleNumber.value}</span>
      <span class="puzzle-status__sep" aria-hidden="true"> • </span>
      <span class="puzzle-status__countdown">Next Puzzle {hms}</span>
    </div>
  );
}
